var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63605 11.293C3.44858 11.4806 3.34326 11.7349 3.34326 12C3.34326 12.2652 3.44858 12.5195 3.63605 12.707L9.29305 18.364C9.3853 18.4595 9.49564 18.5357 9.61764 18.5881C9.73965 18.6405 9.87087 18.6681 10.0036 18.6693C10.1364 18.6704 10.2681 18.6451 10.391 18.5948C10.5139 18.5446 10.6256 18.4703 10.7194 18.3764C10.8133 18.2825 10.8876 18.1709 10.9379 18.048C10.9882 17.9251 11.0135 17.7934 11.0123 17.6606C11.0111 17.5278 10.9836 17.3966 10.9311 17.2746C10.8787 17.1526 10.8026 17.0423 10.707 16.95L6.75705 13L20 13C20.2653 13 20.5196 12.8947 20.7072 12.7071C20.8947 12.5196 21 12.2652 21 12C21 11.7348 20.8947 11.4805 20.7072 11.2929C20.5196 11.1054 20.2653 11 20 11L6.75705 11L10.707 7.05002C10.8892 6.86142 10.99 6.60882 10.9877 6.34662C10.9854 6.08443 10.8803 5.83361 10.6949 5.6482C10.5095 5.4628 10.2586 5.35763 9.99645 5.35535C9.73425 5.35307 9.48165 5.45386 9.29305 5.63602L3.63605 11.293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackArrow);
export default __webpack_public_path__ + "static/media/icon-back-arrow.a073a6d4b3c933c742f243b0e8e8e04e.svg";
export { ForwardRef as ReactComponent };